/**
 * @description 使用者類型 (enum)
 */
export enum UserTypesEnum {
  /** 會員 */
  Member = 'member'
}
